/**
 * Mega Menu 3
 */
(() => {
  const header = document.querySelector('header');
  const megamenu = header?.querySelector('.header-full .megamenu-3');
  const dropdownNav = megamenu?.querySelector('.cd-dropdown');
  if (!dropdownNav) return;

  let activeMenu;

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.cd-dropdown-content > li')) {
      activeMenu?.classList.remove('active');
      dropdownNav.classList.remove('active');
    }
  });

  dropdownNav.querySelectorAll('ul.cd-dropdown-content > li')
    .forEach((item) => {
      const firstLevelAnchor = item.querySelector('a');
      if (!firstLevelAnchor) return;

      const secondLevel = item.querySelector(':scope > ul.cd-secondary-dropdown');
      if (!secondLevel) return;

      const secondLevelLis = secondLevel.querySelectorAll(':scope > li');

      // First level anchor click
      firstLevelAnchor.addEventListener('click', (e) => {
        // If the second level has no children, go to the first level link
        if (secondLevel.querySelectorAll(':scope > li:not(.go-back):not(.menu-icon):not(.menu-background-image)').length < 1) return;

        e.preventDefault();

        if (activeMenu && activeMenu !== item) {
          activeMenu.classList.remove('active');
        }

        activeMenu = item;
        item.classList.toggle('active');

        if (item.classList.contains('active')) {
          dropdownNav.classList.add('active');
        } else {
          dropdownNav.classList.remove('active');
        }
      });

      // Remove the .menu-icon element
      const menuIconElement = secondLevel.querySelector('.menu-icon');
      menuIconElement?.remove();

      // Collect and remove direct text nodes to avoid extra flex items/gaps
      const directTextNodes = Array.from(firstLevelAnchor.childNodes)
        .filter((node) => node.nodeType === Node.TEXT_NODE);
      const firstLevelAnchorContent = directTextNodes
        .map((node) => node.textContent)
        .join(' ')
        .replace(/\s+/g, ' ')
        .trim();
      directTextNodes.forEach((node) => node.remove());

      // Creating the first level anchor content-wrapper
      const firstLevelContentWrapper = document.createElement('span');
      firstLevelContentWrapper.classList.add('text');
      firstLevelContentWrapper.textContent = firstLevelAnchorContent;
      firstLevelAnchor.appendChild(firstLevelContentWrapper);

      // Adding the first level anchor and text to the second level
      const secondLevelMainAnchor = document.createElement('a');
      secondLevelMainAnchor.href = firstLevelAnchor.href;
      secondLevelMainAnchor.textContent = firstLevelAnchorContent;
      secondLevel.prepend(secondLevelMainAnchor);

      if (secondLevelMainAnchor.href === window.location.href) {
        secondLevelMainAnchor.style.pointerEvents = 'none';
      }

      secondLevelLis.forEach((secondTierLink) => {
        const thirdTierLinks = secondTierLink.querySelectorAll('.cd-secondary-dropdown > li > ul > li');
        if (thirdTierLinks.length > 6) {
          const seeMoreLink = document.createElement('a');
          seeMoreLink.classList.add('see-more-link');
          seeMoreLink.textContent = 'See More >';
          seeMoreLink.href = secondTierLink.querySelector('a').href;
          secondTierLink.append(seeMoreLink);
        }
      });

      // If the second level only has the go-back li, add a class to the second level parent
      if (secondLevel.querySelectorAll('li').length === 1) {
        secondLevel.parentElement.classList.add('no-children');
      }
    });
})();
